import { useState, useEffect, useContext } from 'react';
import { DataContext } from '../context/DataContext';
import styled from 'styled-components';
import Button from './Button';
import { QuestionHeader } from '../styled/styles';
import MasterWrapper from './MasterWrapper';
import clearStorage from '../utils/clearStorage';

const StyledTextArea = styled.textarea`
    margin-top: 1em;
    color: #555;
    border: solid 1px transparent;
    min-height: 120px;
    padding-top: 15px;
    padding-bottom: 15px;
    border-radius: 4px;
    line-height: 1.42857143;
    padding: 6px 12px;
    font: normal .8em/1.6 'RobotoRegular', Verdana, Arial, sans-serif;
    box-shadow: 0px 1px 1px rgba(0, 0, 0, 0.25);
    width: 70%;
    border: 1px solid black;
    position: relative;
    left: 2em;
`;

const Option = styled.option`
        color: ${props => props.isSelected ? '#00AEEF' : '#555'};
        background-color: ${props => props.isSelected ? '#D9EEF7' : 'transparent'};
        &:after {
        content: ${props => props.isSelected ? '"✓"' : '""'};
        color: #00AEEF;
        }
    `;

const Select = styled.select`
        option {
        color: #555;
        &::before {
            content: attr(data-before);
            color: #555;
        }
        &::after {
            content: attr(data-after);
            color: #CCC;
        }
        &:hover {
            background-color: #D9EEF7;
        }
        }
        display: block;
        border: none; 
        height: 33.75px; 
        width: 70%;
        padding: 4px; 
        border: 1px solid black;

        position: relative;
        left: 2.8em;
    `;

const SurveyFeedbackButton = styled.button`
        width: 160px;
        margin-top: 19px;
        height: 48px;
        background-color: ${props => props.disabled ? '#D7D7D7' : '#2D66AF'};
        color: ${props => props.disabled ? '#333' : '#fff'};
        border-radius: 4px;
        border: ${props => props.disabled ? '2px solid #D7D7D7' : '2px solid #2D66AF'};    
        cursor: ${props => props.disabled ? 'not-allowed' : 'pointer'};
        margin: 0 auto;  
        margin-top: 3em;
    `

const FinalFeedbackContainer = styled.div`
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
        width: 470px;
        margin: 0 auto;

        @media (max-width: 514px) {
            width: 430px;
        }

        @media (max-width: 488px) {
            width: 392px;
        }

        @media (max-width: 466px) {
            width: 356px;
        }

        @media (max-width: 426px) {
            width: 329px;
        }

        @media (max-width: 375px) {
            width: 305px;
        }
`

const MailToText = ({text}) => {
     
    if (text) {
        let beforeLink = text.split('mailto:')[0]
        let link = text.split('mailto:')[1]
        return (
        <p>
          {beforeLink} <a style={{color: '#0071C5', textDecoration: 'none'}} href={`mailto:${link}`}>{link.split(':')[0].split('?')[0]}</a>
        </p>
        )
      }
}

const ThankYou = ({ parseDynamicQuestionText, serverMessage, chosenLanguage, localizedText }) => {
    const [finalFeedback, setFinalFeedback] = useState(false)
    const [chosenTopic, setChosenTopic] = useState()
    const [comment, setComment] = useState('')
    const [feedbackSubmitted, setFeedbackSubmitted] = useState(false)
    const { englishCode } = useContext(DataContext);

    useEffect(() => {
        clearStorage()
    }, [])


    const topicArray = [
        'Choose a topic',
        'I had a problem while taking the survey',
        'Something in the survey was not relevant to me',
        'I want to share an idea about improving the survey',
        'I need to contact Intel for support',
        'Other'
    ]

    let localTranslations = localizedText?.find(localText => localText.ProjectId === Number.parseInt(chosenLanguage))

      
       
    return (
        <MasterWrapper textAlign={Number.parseInt(chosenLanguage) === englishCode && "center"} flexDirection="column" padding="15px 4px">
            {serverMessage ?
                <>
                    <QuestionHeader dangerouslySetInnerHTML={{ __html: serverMessage}} />
                    <MailToText text={localTranslations ? localTranslations?.ContactInfo : ''} />
                </>
            :
            <>
            <QuestionHeader dangerouslySetInnerHTML={{ __html: localTranslations ? localTranslations?.ThankYouMessage : "Thank you for taking the time to complete this survey. Your feedback will help us continue to improve the Intel Customer Support experience."}} />

            {(!finalFeedback && Number.parseInt(chosenLanguage) !== englishCode) && <MailToText text={localTranslations ? localTranslations?.ContactInfo : ''} />}

            {(!feedbackSubmitted && Number.parseInt(chosenLanguage) === englishCode) && <p>We also welcome your input about the <span style={{ textDecoration: 'underline' }}>survey</span> experience!</p>}

            {finalFeedback && !feedbackSubmitted &&
                <FinalFeedbackContainer>
                    <QuestionHeader>Topic:</QuestionHeader>
                    <Select onChange={(e) => setChosenTopic(e.target.value)} value={chosenTopic ? chosenTopic : 'Choose a topic'}>
                        {topicArray.map(topic => (
                            <Option key={topic} value={topic} isSelected={topic === chosenTopic}>
                                {topic}
                            </Option>
                        ))}
                    </Select>
                </FinalFeedbackContainer>}

            {finalFeedback && !feedbackSubmitted &&
                <FinalFeedbackContainer>
                    <QuestionHeader>Comment:</QuestionHeader>
                    <StyledTextArea value={comment} onChange={(e) => setComment(e.target.value)} placeholder="Please provide your survey feedback here" />
                </FinalFeedbackContainer>}

            {finalFeedback && !feedbackSubmitted && <p>Follow this <a style={{ color: '#0071C5', textDecoration: 'none' }} target="_blank" href="https://www.intel.com/content/www/us/en/support.html">link</a> to view Intel customer support options.</p>}

            {finalFeedback && !feedbackSubmitted &&
                <SurveyFeedbackButton disabled={!chosenTopic || (!comment || comment === '')} onClick={() => setFeedbackSubmitted(true)}>
                    Submit
                </SurveyFeedbackButton>}

            {!finalFeedback && !feedbackSubmitted && window.location.href.split('pid=')[1].split('&')[0] === englishCode && sessionStorage.sid === '18JT014' &&
                <SurveyFeedbackButton onClick={() => {
                    setFinalFeedback(true)
                }}>
                    Give Survey Feedback
                </SurveyFeedbackButton>}

            {feedbackSubmitted && <>
                <p>Thank you for your feedback!</p>

                <img style={{margin: '0 auto'}} width="109" height="94" src={`${process.env.PUBLIC_URL}/checkmark.png`} alt="Checkmark" />
            </>}
            </>
            }
        </MasterWrapper>
        
    );
};

export default ThankYou;